// Mémorise l'inscription pour ne pas reproposer la lettre à chaque trace : sur un
// même séjour, un randonneur télécharge souvent les étapes les unes après les autres.
const newsletterKey = "altimood-newsletter";

export function initGpxDownloadModal() {
  document.addEventListener("click", (e) => {
    const trigger = e.target.closest(".gpx-download-trigger");
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    showGpxModal(trigger.dataset);
  });
}

function newsletterAlreadyDone() {
  try {
    return localStorage.getItem(newsletterKey) === "1";
  } catch {
    return false; // navigation privée : on reproposera, tant pis
  }
}

function rememberNewsletterDone() {
  try {
    localStorage.setItem(newsletterKey, "1");
  } catch {
    /* idem */
  }
}

function fileName(url) {
  return url.split("/").pop();
}

function showGpxModal(gpx) {
  const withNewsletter =
    Boolean(gpx.gpxNewsletterUrl) && !newsletterAlreadyDone();

  const newsletterBlock = withNewsletter
    ? `<p class="mb-4 text-gray-700">${gpx.gpxDoneMessage}</p>
       <div class="gpx-modal-newsletter mb-6"></div>`
    : "";

  const overlay = document.createElement("div");
  overlay.className =
    "fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4";
  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-modal", "true");
  overlay.setAttribute("aria-labelledby", "gpx-modal-title");

  overlay.innerHTML = `
    <div class="prose relative mx-auto max-h-[90vh] max-w-lg overflow-y-auto rounded-2xl bg-white p-8 shadow-2xl">
      <button type="button" aria-label="${gpx.gpxCancelLabel}"
        class="gpx-modal-close absolute top-3 right-3 text-2xl leading-none text-gray-400 hover:text-gray-700 no-underline">&times;</button>
      <h2 id="gpx-modal-title" class="mb-4 text-xl font-bold text-gray-900">${gpx.gpxTitle}</h2>

      <div class="gpx-modal-disclaimer">
        <p class="mb-6 text-gray-700">${gpx.gpxMessage}</p>
        <div class="flex gap-4 justify-end">
          <button type="button"
            class="gpx-modal-cancel cursor-pointer rounded-lg border border-gray-300 px-5 py-2.5 font-semibold text-gray-700 hover:bg-gray-100">${gpx.gpxCancelLabel}</button>
          <a href="${gpx.gpxUrl}" download
            class="gpx-modal-confirm rounded-lg bg-primary px-5 py-2.5 font-semibold !text-white no-underline hover:opacity-90">${gpx.gpxDownloadLabel}</a>
        </div>
      </div>

      <div class="gpx-modal-done hidden">
        <p class="mt-0 mb-6 text-sm text-gray-500">${fileName(gpx.gpxUrl)}</p>
        ${newsletterBlock}
        <p class="mb-6 text-sm text-gray-500">${gpx.gpxFallback}
          <a href="${gpx.gpxUrl}" download>${gpx.gpxFallbackLink}</a></p>
        <div class="flex justify-end">
          <button type="button"
            class="gpx-modal-done-close cursor-pointer rounded-lg border border-gray-300 px-5 py-2.5 font-semibold text-gray-700 hover:bg-gray-100">${gpx.gpxDoneClose}</button>
        </div>
      </div>
    </div>
  `;

  const close = () => {
    overlay.remove();
    document.removeEventListener("keydown", onKeydown);
  };

  const onKeydown = (e) => {
    if (e.key === "Escape") close();
  };

  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) close();
  });
  overlay.querySelector(".gpx-modal-close").addEventListener("click", close);
  overlay.querySelector(".gpx-modal-cancel").addEventListener("click", close);
  overlay
    .querySelector(".gpx-modal-done-close")
    .addEventListener("click", close);

  // Pas de preventDefault et pas de suppression du lien : le navigateur lance le
  // téléchargement nativement, on se contente de basculer d'étape à côté.
  overlay.querySelector(".gpx-modal-confirm").addEventListener("click", () => {
    window._paq &&
      window._paq.push([
        "trackEvent",
        "Engagement",
        "GPX download",
        fileName(gpx.gpxUrl),
      ]);
    showDoneStep(overlay, gpx, withNewsletter);
  });

  document.addEventListener("keydown", onKeydown);

  document.body.appendChild(overlay);
  overlay.querySelector(".gpx-modal-cancel").focus();
}

function showDoneStep(overlay, gpx, withNewsletter) {
  overlay.querySelector(".gpx-modal-disclaimer").classList.add("hidden");
  overlay.querySelector(".gpx-modal-done").classList.remove("hidden");
  overlay.querySelector("#gpx-modal-title").innerHTML = gpx.gpxDoneTitle;
  overlay
    .querySelector(".gpx-modal-close")
    .setAttribute("aria-label", gpx.gpxDoneClose);

  if (withNewsletter) {
    // data-live posé maintenant seulement : liveBlock() (app.js) va chercher le
    // formulaire sur le host dynamique et remplace ce bloc par sa réponse.
    overlay
      .querySelector(".gpx-modal-newsletter")
      .setAttribute("data-live", "e:" + gpx.gpxNewsletterUrl);
    document.dispatchEvent(new Event("DOMChanged"));

    overlay.addEventListener("submit", rememberNewsletterDone, { once: true });
  }

  overlay.querySelector(".gpx-modal-done-close").focus();
}
